import { CircleAlert, X } from 'lucide-react';

export function NexusErrorBanner({ message, onDismiss }: { message: string; onDismiss: () => void }) {
  return (
    <div className="mt-4 flex items-start justify-between gap-3 rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-700">
      <div className="flex items-start gap-2">
        <CircleAlert className="mt-0.5 h-4 w-4 shrink-0" />
        <span>{message}</span>
      </div>
      <button type="button" onClick={onDismiss} aria-label="Dismiss message">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
